<div class="panel panel-default">
	<div class="panel-body">
		<div class="row">
			<div class="col-md-12">
				<button type="button" class="btn btn-lg btn-primary" (click)="forceWebsiteRefresh()">{{'admin.force_website_refresh' | translate}}</button>
			</div>
		</div>
	</div>
</div>